"use client"

import type { ReactNode } from "react"
import { RegularLinkButton } from "@/components/Button/RegularLinkButton/RegularLinkButton.component"
import type { CommonButtonProps } from "@/components/Button/regular-button.types"
import { useFeatureFlag } from "@/contexts/feature-flag/feature-flag-context"
import { useCurrentUrl } from "@/hooks/use-current-url.hook"
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook"

type LoginButtonProps = Pick<CommonButtonProps, "position" | "variant"> & {
  readonly className?: string
  readonly children: ReactNode
  readonly redirectTo?: string
}

export function LoginButton({
  children,
  className,
  position,
  redirectTo,
  variant = "primary",
}: LoginButtonProps) {
  const { urls } = useAuthentication()
  const { relative: currentRelativeUrl } = useCurrentUrl()

  const isPaywallDisabled = useFeatureFlag("disable-paywall")

  if (!urls) {
    return null
  }

  const { createLogin } = urls
  const href = createLogin(redirectTo ?? currentRelativeUrl)

  if (isPaywallDisabled || !href) {
    return null
  }

  return (
    <RegularLinkButton
      className={className}
      href={href}
      openInNewTab={false}
      position={position}
      variant={variant}
    >
      {children}
    </RegularLinkButton>
  )
}
